import { useCallback } from 'react';

import { useStarterDashboardV2BannerState } from 'src/app/pages/starterDashboardV2/pageContext';

export function usePageBanner() {
	const { data, actions } = useStarterDashboardV2BannerState();

	const handleDismiss = useCallback(
		(e: React.MouseEvent<HTMLButtonElement>) => {
			if (!data.currentBanner) return;
			data.currentBanner.onClose?.(e);
			actions.dismissBanner();
		},
		[actions, data.currentBanner],
	);

	// ALERTS: comment this line
	return { data: { banner: data.currentBanner }, actions: { onDismiss: handleDismiss } };
	// return { data: { banner: {
	// 	severity: 'success',
	// 	message: 'Test',
	// } as any }, actions: { onDismiss: handleDismiss } };
}
